export default __webpack_public_path__ + "static/media/video-games.fd21f239.jpeg";